import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.pending = 0
    this.visible = false
    this.showTimer = null
    this.showDelay = 120

    this.onFetchRequest = this.handleFetchRequest.bind(this)
    this.onFetchResponse = this.handleFetchResponse.bind(this)
    this.onFetchError = this.handleFetchError.bind(this)
    this.onSpinnerShow = this.begin.bind(this)
    this.onSpinnerHide = this.end.bind(this)
    this.onTurboLoad = this.reset.bind(this)

    document.addEventListener("turbo:before-fetch-request", this.onFetchRequest)
    document.addEventListener("turbo:before-fetch-response", this.onFetchResponse)
    document.addEventListener("turbo:fetch-request-error", this.onFetchError)
    document.addEventListener("spinner:show", this.onSpinnerShow)
    document.addEventListener("spinner:hide", this.onSpinnerHide)
    document.addEventListener("turbo:load", this.onTurboLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.onFetchRequest)
    document.removeEventListener("turbo:before-fetch-response", this.onFetchResponse)
    document.removeEventListener("turbo:fetch-request-error", this.onFetchError)
    document.removeEventListener("spinner:show", this.onSpinnerShow)
    document.removeEventListener("spinner:hide", this.onSpinnerHide)
    document.removeEventListener("turbo:load", this.onTurboLoad)
    this.clearShowTimer()
  }

  handleFetchRequest(event) {
    if (this.isPrefetch(event)) return
    this.begin()
  }

  handleFetchResponse(event) {
    if (this.isPrefetch(event)) return
    this.end()
  }

  handleFetchError() {
    this.end()
  }

  isPrefetch(event) {
    const headers = event.detail?.fetchOptions?.headers || {}
    return headers["X-Sec-Purpose"] === "prefetch" || headers["Sec-Purpose"] === "prefetch"
  }

  begin() {
    this.pending += 1
    if (this.pending === 1) this.scheduleShow()
  }

  end() {
    this.pending = Math.max(0, this.pending - 1)
    if (this.pending === 0) this.hideNow()
  }

  reset() {
    this.pending = 0
    this.hideNow()
  }

  scheduleShow() {
    this.clearShowTimer()
    if (this.visible) return
    this.showTimer = setTimeout(() => this.showNow(), this.showDelay)
  }

  showNow() {
    if (!this.hasContainerTarget || this.visible || this.pending === 0) return
    this.containerTarget.classList.remove("hidden")
    this.visible = true
  }

  hideNow() {
    this.clearShowTimer()
    if (!this.hasContainerTarget || !this.visible) return
    this.containerTarget.classList.add("hidden")
    this.visible = false
  }

  clearShowTimer() {
    if (!this.showTimer) return
    clearTimeout(this.showTimer)
    this.showTimer = null
  }
}
